import useTranslations from "@/hooks/useTranslations";

export default function HomePageContent() {
    const { __ } = useTranslations();

    return (
        <>
            <section className="bg-gray-50 dark:bg-gray-800 py-14 my-10">
                <div className="container mx-auto space-y-4">
                    <div className="text-center">
                        <h3 className="text-2xl mb-8 font-bold text-gray-900 dark:text-gray-100">{__('home.why_choose.title')}</h3>
                    </div>
                    <div className="grid md:grid-cols-3 gap-4 text-center">
                        <div className="p-4">
                            <h4 className="font-bold mb-2 text-gray-900 dark:text-gray-100">{__('home.features.ai_accuracy.title')}</h4>
                            <p className="text-gray-700 dark:text-gray-300">{__('home.features.ai_accuracy.description')}</p>
                        </div>
                        <div className="p-4">
                            <h4 className="font-bold mb-2 text-gray-900 dark:text-gray-100">{__('home.features.supports_languages.title')}</h4>
                            <p className="text-gray-700 dark:text-gray-300">{__('home.features.supports_languages.description')}</p>
                        </div>
                        <div className="p-4">
                            <h4 className="font-bold mb-2 text-gray-900 dark:text-gray-100">{__('home.features.fast_reliable.title')}</h4>
                            <p className="text-gray-700 dark:text-gray-300">{__('home.features.fast_reliable.description')}</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="my-12 mb-6 px-4 md:px-5 lg:px-10">
                <div className="container mx-auto">
                    <div className="text-gray-600 dark:text-gray-400 text-sm">
                        <p>{__('home.description.paragraph_1')}</p>
                        <p className="mt-4">{__('home.description.paragraph_2')}</p>
                        <p className="mt-4">{__('home.description.paragraph_3')}</p>
                    </div>
                </div>
            </section>
        </>
    );
}
